import React, {useMemo} from 'react';
import router, {Route} from "@/routing/Router";
import AdminLayout from "@widgets/layout/AdminLayout";
import SynchronizationOverview from "@widgets/synchronization/overview/SynchronizationOverview";


const Synchronization = () => {
    const route: Route = useMemo(() => router.synchronization, []);

    return (
        <AdminLayout currentPage={route}>
            <SynchronizationOverview/>
        </AdminLayout>
    );
};

export default Synchronization;